import { useCancelContact, useVerifyContact } from '../../hooks/useProfile';

import VerifyToken, { VerifyTokenFormProps } from './VerifyTokenForm';

export interface VerifyContactFormProps extends Omit<
    VerifyTokenFormProps,
    'postForm' | 'onClickCancel'
> {
    contact: UserContact;
    onCancel?: (() => void) | null;
}

function VerifyContact({ contact, onCancel = null, ...props }: VerifyContactFormProps) {
    const { verifyContactAsync } = useVerifyContact();
    const { cancelContact } = useCancelContact();
    const postForm = (actionForm: string, data: { token: string }) =>
        verifyContactAsync({
            contact,
            ...data,
        });
    const onClickCancel = () => {
        cancelContact(contact);
        if (onCancel !== null) {
            onCancel();
        }
    };
    return <VerifyToken postForm={postForm} onClickCancel={onClickCancel} {...props} />;
}

export default VerifyContact;
